module.exports = __webpack_public_path__ + "static/img/product10.ae20c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product10.png
// module id = f/4k
// module chunks = 10